import { createSvgComponent } from "../../icon/createSvgComponent";
import Wello from "@core/__generated__/icon/figma/wello.svg";
export default createSvgComponent(Wello);